<template>
    <!-- 个人订单操作 -->
    <div>
        <el-card class="container" v-show="!applicationPrePage && !mallInvoiceApplyPage" shadow="never">
            <div slot="header">
                <div class="tabBar">
                    <div class="tabBar-item" :class="{'tabBar-itam-active': item.index == operateIndex, 'cursor-item': item.index != operateIndex}" v-for="item in tabBarList" :key="item.index" @click="changeOperate(item.index)"> {{ item.label }} </div>
                </div>
                <div class="desc"> {{ activeTabBarItem.desc }} </div>
            </div>
            <!-- 筛选框 -->
            <div class="serach-box">
                <div v-show="operateIndex == 1">
                    <span>支付方式： </span>
                    <el-select v-model="paymentData" placeholder="请选择支付方式" @change="changePrepaidPayment">
                        <el-option v-for="item in paymentList" :key="item.value" :label="item.label" :value="item"></el-option>
                    </el-select>
                </div>
                <div v-show="[1, 3].includes(operateIndex)">
                    <span>预约检测设备： </span>
                    <el-select v-model="orderListParams.keyWord" remote clearable filterable placeholder="请选择" :remote-method="remoteEqList" @change="getOrderList">
                        <el-option v-for="(item, index) in equipmentList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div v-show="operateIndex == 1 || operateIndex == 3">
                    <span>下单时间： </span>
                    <el-date-picker class="timePicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" v-model="timeRange" @change="changeTimeRange"></el-date-picker>
                </div>
                <div v-if="[3].includes(operateIndex)">
                    <span class="item-title">开票状态：</span>
                    <el-select v-model="orderListParams.billStatus" clearable placeholder="请选择" @change="getOrderList">
                        <el-option
                          v-for="item in billStatusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-show="operateIndex == 4">
                    <span>订单号： </span>
                    <el-input class="filter-input" clearable placeholder="请输入订单号" v-model.trim="orderListParams.orderNo" @keyup.enter.native="getMallInvoiceSearch" @clear="getMallInvoiceSearch"></el-input>
                </div>
                <div v-show="operateIndex == 4">
                    <span>商品名称： </span>
                    <el-input class="filter-input" clearable placeholder="请输入商品名称" v-model.trim="orderListParams.productName" @keyup.enter.native="getMallInvoiceSearch" @clear="getMallInvoiceSearch"></el-input>
                </div>
                <div v-show="operateIndex == 4">
                    <span>支付方式： </span>
                    <el-select class="filter-input" v-model="orderListParams.payType" clearable placeholder="请选择支付方式" @change="getMallInvoiceSearch">
                        <el-option
                          v-for="item in mallInvoicePayTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-show="operateIndex == 4">
                    <el-button @click="resetMallInvoiceParams">重置</el-button>
                    <el-button type="primary" @click="getMallInvoiceSearch">搜索</el-button>
                </div>
			</div>
            <el-table v-if="operateIndex !== 4" key="detect-order-table" ref="table" class="disable-table-select-all" :height="tableHeight" :header-cell-style="{background:'#F5F5F5'}" v-loading="loading" :data="orderList" :border="true" @selection-change="selectOrder" @select-all="handleSelectAll">
                <el-table-column type="selection" width="55" align="center" :selectable="handleSelectable"></el-table-column>
                <el-table-column label="设备" width="140" align="center">
                    <template slot-scope="scope">
                        <img class="equipmentPic" :src="scope.row.equipmentPic" alt="">
                    </template>
                </el-table-column>
                <el-table-column label="订单号" prop="orderCode" width="160" align="center"></el-table-column>
                <el-table-column label="预约检测名称" prop="equipmentName" width="240" align="center"></el-table-column>
                <el-table-column label="样品总数" prop="sampleNumber" width="100" align="center"></el-table-column>
                <el-table-column label="检测金额（元）" width="120" align="center">
                    <template slot-scope="scope">
                        <span>￥ {{ scope.row.experimentTotalCost }} </span>
                    </template>
                </el-table-column>
                <el-table-column label="支付方式" width="100" align="center">
                    <template slot-scope="scope">
                        {{ dictFilter(scope.row.prepaidPayment ? scope.row.prepaidPayment.toString() : '-', 'prepaidPayment') }}
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" prop="orderDate" width="180" align="center"></el-table-column>
                <el-table-column label="完成时间" prop="finishOrderDate" width="180" align="center"></el-table-column>
                <el-table-column label="订单备注" prop="customRemark" min-width="180" align="center"></el-table-column>
            </el-table>
            <el-table v-else key="mall-invoice-table" ref="table" class="disable-table-select-all" :height="tableHeight" :header-cell-style="{background:'#F5F5F5'}" v-loading="loading" :data="orderList" :border="true" @selection-change="selectOrder" @select-all="handleSelectAll">
                <el-table-column type="selection" width="55" align="center" :selectable="handleSelectable"></el-table-column>
                <el-table-column label="订单号" prop="orderNo" min-width="180" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="商品名称" prop="firstGoodsName" min-width="240" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="订单价格" width="120" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.totalAmount }}</template>
                </el-table-column>
                <el-table-column label="支付方式" width="120" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.payTypeText || dictFilter(scope.row.payType ? scope.row.payType.toString() : '-', 'prepaidPayment') }}
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" prop="createdAt" width="180" align="center"></el-table-column>
            </el-table>
            <div class="table-footer">
                <div class="button-box">
                    <el-button type="primary" :disabled="!selectList.length" @click="operateButton(operateIndex)"> {{ operateButtonLabel }} </el-button>
                    <div v-if="[0, 1, 4].includes(operateIndex)">总计： ￥{{ experimentTotalCost }}</div>
                    <div v-if="[2, 3].includes(operateIndex)">共选中： {{ selectList.length }}条</div>
                </div>
                <el-pagination background v-if="total > 0" style="text-align: right;margin-top: 10px;margin-left: auto"
                    layout="total,prev, pager, next,sizes,jumper" :current-page="orderListParams.pageNum"
                    :page-size="orderListParams.pageSize" :total="total" @current-change="selPageChange"
                    @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </el-card>
        
        <!-- 立即还款弹框 -->
        <el-dialog title="温馨提示" :visible.sync="repayDialog" width="30%" :close-on-click-modal="false" @closed="closeRepayDialog">
            <div class="repay-dialog">
                <div class="repay-item">
                    <div class=item-title>还款金额：</div>
                    <div>￥ {{ experimentTotalCost }} </div>
                </div>
                <div class="repay-item">
                    <div class=item-title>支付方式：</div>
                    <div>预存支付</div>
                </div>
                <!-- <div class="repay-item">
                    <div class=item-title>支付方式：</div>
                    <div>
                        <el-radio v-model="repayment" label="1" border>预存支付</el-radio>
                        <el-radio v-model="repayment" label="2" border>微信支付</el-radio>
                    </div>
                </div>
                <div class="repay-item" v-show="repayment == 2">
                    <div class=item-title>微信支付码：</div>
                    <img class="wxQrCode" src="" alt="">
                </div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="repayDialog = false">取 消</el-button>
                <el-button type="primary" :loading="repayLoading"  @click="repay">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 申请开票 -->
        <applicationPre v-show="applicationPrePage" ref="applicationPre" @goBack="applicationPrePage = false" @backAndRefresh="backAndRefresh"></applicationPre>
        <!-- 耗材开票 -->
        <mallInvoiceApply v-if="mallInvoiceApplyPage" ref="mallInvoiceApply" @goBack="mallInvoiceApplyPage = false" @backAndRefresh="backMallInvoiceAndRefresh"></mallInvoiceApply>
        <!-- 实验结果发送邮箱 -->
        <el-dialog title="温馨提示" :visible.sync="EmailDialog" width="30%" :close-on-click-modal="false" @closed="closeEmailDialog">
            <el-input :class="{'validate-false': !emailValidate}" placeholder="请输入用以接收实验结果的邮箱" v-model="email" @blur="validateEmail">
                <template slot="prepend">邮箱地址</template>
            </el-input>
            <div style="color: #FF4A2B; height: 20px;"> {{ !emailValidate ? '邮箱格式错误' : '' }} </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="EmailDialog = false">取 消</el-button>
                <el-button type="primary" :loading="EmailLoading" :disabled="!emailValidate || !email" @click="mailSend">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getClient } from "@/plugins/auth";
import { memberOrderList, orderRepayment, EMailSend, invoiceResultExport, equipList, mallInvoiceAvailableOrderList, mallOrderInfo } from "@/api/request.js"
import applicationPre from './formPop/applicationPre.vue';
import mallInvoiceApply from './mallInvoiceApply.vue';

export default {
    components: { applicationPre, mallInvoiceApply },
    data() {
        return {
            userInfo: JSON.parse(getClient()),
            imgurl: process.env.VUE_APP_FILE_API,
            applicationPrePage: false,//是否显示申请开票页
            mallInvoiceApplyPage: false,//是否显示耗材开票组件
            loading: false,//table的loading
            emailValidate: true,//邮箱校验结果
            EmailDialog: false,//实验结果发送邮箱弹框
            EmailLoading: false,//发送邮箱按钮防抖
            repayDialog: false,//立即还款弹框
            repayLoading: false,//立即还款按钮防抖
            total: 0,
            operateIndex: 0,
            tabBarList: [
                { label: '立即还款', desc: '使用预付金额还款存在重复开票行为，此类订单无法开票，如已开票将以废票处理。', index: 0 },
				{ label: '检测开票', desc: '个人财务支付的【已完成】订单可索取发票，信用与现金支付不可组合开票，2025年4月前的订单请联系客服开票！', index: 1 },
				{ label: '耗材开票', desc: '个人财务支付的【已完成】订单可索取发票，信用与现金支付不可组合开票！', index: 4 },
				{ label: '下载实验结果', desc: '已开通邮箱传送功能！！！小文件将以附件形式发送，大文件将以内嵌下载链接方式传输！', index: 2 },
				{ label: '下载对账单', desc: '处于“已完成”状态的订单可下载对账单，对账单合并下载后将在同一个表格中统计，请按需提交下载。', index: 3 },
            ],
            // 开发票---支付方式筛选
			paymentData: {},
			paymentList: [
				{ label: '全部', index: 0 },
				{ label: '个人信用', index: 1, value: 5 },
				{ label: '团队信用', index: 2, value: 6 },
				{ label: '微信', index: 3, value: 4 },
				{ label: '支付宝', index: 4, value: 3 },
			],
            // 耗材开票接口会自动排除预存支付，仅展示可开票支付类型。
            mallInvoicePayTypeList: [
                { label: '支付宝', value: '3' },
                { label: '微信', value: '4' },
                { label: '个人信用', value: '5' },
                { label: '团队信用', value: '6' },
            ],
            timeRange: [],//存储 --- 时间筛选值
            //开票状态筛选
            billStatusList: [
              {label: '未开票', value: 1}, 
              {label: '已开票', value: 2},
              {label: '无需开票', value: 3},
            ],
            // 订单列表查询接口上传参数
            orderListParams: {
                pageSize: 10,
				pageNum: 1,
            },
            orderList: [],//订单列表
            selectList: [],//勾选的订单列表
            repayment: '1',//还款支付方式
            orderRepaymentData: {},//预存还款接口上传参数
            email: '',//邮箱
            equipmentList: [],//设备列表
        }
    },
    computed: {
        activeTabBarItem() {
            return this.tabBarList.find(item => item.index == this.operateIndex) || this.tabBarList[0]
        },
        tableHeight() {
            if(this.operateIndex == 1 || this.operateIndex == 3 || this.operateIndex == 4) {
                return 'calc(100vh - 500px)'
            }
            return 'calc(100vh - 450px)'
        },
        operateButtonLabel() {
			let str = ''
			switch(this.operateIndex) {
				case 0:
				    str = '立即还款'
					break
				case 1:
				    str = '立即开票'
                    break
				case 2:
				    str = '发送到邮箱'
					break
				case 3:
				    str = '下载对账单'
					break
                case 4:
				    str = '立即开票'
					break
			}
			return str
		},
        experimentTotalCost() {
			const list = []
            this.selectList.forEach(item => {
                const obj = this.orderList.find(item_ => item_.orderId == item)
                if(!obj) return
                if(this.operateIndex == 4) {
                    list.push(obj.paidAmount)
                } else {
                    list.push(obj.experimentTotalCost)
                }
			})
			const experimentTotalCost = list.reduce((sum, item) => {
				return sum + item
			}, 0)
			return experimentTotalCost.toFixed(2)
		},
    },
    async mounted() {
        const routeOperateIndex = Number(this.$route.query.operateIndex)
        const orderId = Number(this.$route.query.mallInvoiceOrderId)
        const defaultOperateIndex = this.tabBarList.some(item => item.index === routeOperateIndex) ? routeOperateIndex : 0
        await this.changeOperate(defaultOperateIndex)
        if(defaultOperateIndex == 4 && orderId) {
            this.openMallInvoiceApplyFromRoute(orderId)
        }
        this.remoteEqList()
    },
    methods: {
        //获取订单列表
        async getOrderList() {
            if(this.operateIndex === 4) {
                await this.getMallInvoiceOrderList()
                return
            }
            try {
                this.loading = true
                const res = await memberOrderList(this.orderListParams)
                if(res.data.data.list.length) {
                    res.data.data.list.forEach(item => {
			         	item.equipmentPic = (item.fileList && item.fileList.length) ? this.imgurl + item.fileList[0].url : ''
			        })
                }
                this.total = res.data.data.total;
                this.orderList = res.data.data.list
                this.loading = false
            }
            catch(err) {
                console.log(err)
                this.loading = false
            }
        },
        // 获取耗材待开票订单列表
        async getMallInvoiceOrderList() {
            try {
                this.loading = true
                // 耗材开票只查询后端判定的商城可开票订单，避免复用商城订单总列表造成状态口径偏差。
                const res = await mallInvoiceAvailableOrderList(this.orderListParams)
                const rows = this.extractMallOrderRows(res)
                this.orderList = rows.map(this.normalizeMallInvoiceOrder)
                this.total = this.extractMallOrderTotal(res, rows.length)
            } catch(err) {
                console.log(err)
                this.orderList = []
                this.total = 0
            } finally {
                this.loading = false
            }
        },
        // 耗材开票筛选查询
        getMallInvoiceSearch() {
            this.orderListParams.pageNum = 1
            this.getOrderList()
        },
        // 重置耗材开票筛选条件
        resetMallInvoiceParams() {
            this.orderListParams = this.getDefaultMallInvoiceParams()
            this.getOrderList()
        },
        // 获取耗材开票默认查询参数
        getDefaultMallInvoiceParams() {
            return {
                subjectScope: 'PERSONAL', //个人类型的耗材订单开票
                pageSize: 10,
                pageNum: 1,
                orderNo: '',
                productName: '',
                payType: '',
            }
        },
        extractMallOrderRows(res) {
            const data = res && res.data
            if(Array.isArray(res && res.rows)) return res.rows
            if(data && Array.isArray(data.rows)) return data.rows
            if(data && Array.isArray(data.list)) return data.list
            if(data && data.data && Array.isArray(data.data.list)) return data.data.list
            return []
        },
        extractMallOrderTotal(res, fallback) {
            const data = res && res.data
            return Number((res && res.total) || (data && data.total) || (data && data.data && data.data.total)) || fallback
        },
        normalizeMallInvoiceOrder(item) {
            const amount = item.totalAmount != null
                ? item.totalAmount
                : (item.amount && item.amount.totalAmount != null ? item.amount.totalAmount : item.amount)
            return {
                ...item,
                orderId: item.orderId || item.id,
                orderNo: item.orderNo || item.id || '-',
                firstGoodsName: item.firstGoodsName || item.productName || item.goodsName || '-',
                totalAmount: Number(amount || 0).toFixed(2),
                payType: item.payType,
                payTypeText: item.payTypeText || '',
                createdAt: item.createdAt || item.addDate || '-'
            }
        },
        //更改页码
        selPageChange(page) {
            this.clearTableCheck()
            this.orderListParams.pageNum = page;
            this.getOrderList();
        },
        // 更改页面item数量
        handleSizeChange(val) {
            this.clearTableCheck()
            this.orderListParams.pageSize = val;
            this.getOrderList();
        },
        // 清空table的勾选
        clearTableCheck() {
            this.selectList = []
            if(this.$refs.table) {
                this.$refs.table.clearSelection()
            }
        },
        // 耗材开票订单是否可以勾选
        handleSelectable(row) {
            const key = this.operateIndex == 4 ? 'payType' : 'prepaidPayment'
            const pay1 = [1, 2, 5, 6]//平台支付方式
            const pay2 = [3, 4]//现金支付方式
            const data = this.orderList.find(i => i.orderId == this.selectList[0])
            if(![1, 4].includes(this.operateIndex) || !data) return true
            let rootType
            if(pay1.some(i => i == data[key])) rootType = 1
            else if(pay2.some(i => i == data[key])) rootType = 2
            else rootType = 3
            let targetType
            if(pay1.some(i => i == row[key])) targetType = 1
            else if(pay2.some(i => i == row[key])) targetType = 2
            else targetType = 3
            return targetType != 3 && targetType == rootType
        },
        //更改订单操作tab
        async changeOperate(index) {
            if(this.loading) {
                return
            }
            this.orderList = []
            this.loading = true
            this.operateIndex = index
            this.mallInvoiceApplyPage = false
            this.paymentData = {}
            this.timeRange = []
            this.clearTableCheck()
            switch(index) {
				case 0:
				    // 立即还款
				    this.orderListParams = {
				    	pageSize: 10,
				    	pageNum: 1,
				    	status: 7,
				    	paymentStatus: 1,
				    	billStatus: 1,
				    	prepaidPayment: 5
				    }
					break
				case 1:
				    // 开发票
				    this.orderListParams = {
				    	pageSize: 10,
				    	pageNum: 1,
				    	status: 7,
				    	billStatus: 1,
				    	noPrepaidPayments: '1,2',
						gteDetectionEndDate: '2025-04-01 00:00:00',
                        keyWord: '',
				    }
					break
				case 2:
				    // 下载实验结果
				    this.orderListParams = {
				    	pageSize: 10,
				    	pageNum: 1,
				    	statuss: '7,9',
						emailSendFlag: 1,
				    }
					break
				case 3:
				    // 下载对账单
				    this.orderListParams = {
				    	pageSize: 10,
				    	pageNum: 1,
				    	statuss: '7,9',
				    	billStatus: 1,
						orderDateBegin: '',
						orderDateEnd: '',
                        keyWord: '',
				    }
					break
                case 4:
                    // 耗材开票使用商城可开票订单接口，筛选参数与后端接口文档保持一致。
                    this.orderListParams = this.getDefaultMallInvoiceParams()
                    break
			}
            await this.getOrderList()
            this.$forceUpdate()
        },
        // 切换支付方式
		changePrepaidPayment(data) {
            this.clearTableCheck()
            if(data.index) {
                this.orderListParams.prepaidPayment = data.value
            } else {
                this.orderListParams = {
					pageSize: 15,
					pageNum: 1,
					pageNum_max: 1,
					status: 7,
					billStatus: 1,
					noPrepaidPayments: '1,2',
					gteDetectionEndDate: '2025-04-01 00:00:00'
				}
            }
			this.getOrderList()
		},
        //设备远程搜索
        async remoteEqList(value) {
            const parmas = {
                pageNum: 1,
                pageSize: 10,
                status: 1,
                equipmentName: value,
            }
            const res = await equipList(parmas)
            this.equipmentList = res.rows.map(item => {
                return {
                    label: item.equipmentName,
                    value: item.equipmentName,
                }
            })
        },
        // 时间筛选
        changeTimeRange(e) {
            if(e) {
                this.clearTableCheck()
                this.orderListParams.orderDateBegin = e[0]
		        this.orderListParams.orderDateEnd = e[1]
		        this.getOrderList()
            } else {
                this.clearTableCheck()
                this.orderListParams.orderDateBegin = undefined
		        this.orderListParams.orderDateEnd = undefined
		        this.getOrderList()
            }
        },
        // 表格仅允许逐行选择，忽略表头全选操作
        handleSelectAll() {
            this.$refs.table.clearSelection()
        },
        // 设置已选择的订单列表
        selectOrder(e) {
           this.selectList = e.map(item => item.orderId)
        },
        //操作按钮
        async operateButton(index) {
            switch(index) {
                case 0:
                    //立即还款
                    this.orderRepaymentData = {
                        type: 2,
                        orderIds: this.selectList,
                    }
                    this.repayDialog = true
                    break
                case 1:
                    //开发票
                    const invoiceList = []
                    this.selectList.forEach(item => {
                        const obj = this.orderList.find(item_ => item_.orderId == item)
                        invoiceList.push({
                            orderId: obj.orderId,
                            prepaidPayment: obj.prepaidPayment,
                        })
                    })
                    this.applicationPrePage = true
                    this.$refs.applicationPre.init(1, invoiceList, this.experimentTotalCost)
                    break
                case 2:
                    //下载实验结果
                    this.EmailDialog = true
                    this.email = this.userInfo.email
                    if(this.email) {
                        this.validateEmail()
                    }
                    break
                case 3:
                    //下载对账单
                    const orderCodesList = []
                    this.selectList.forEach(item => {
                        const orderCode = this.orderList.find(item_ => item_.orderId == item).orderCode
                        orderCodesList.push(orderCode)
                    })
                    const exportRes = await invoiceResultExport({orderCodes: orderCodesList.join(',')})
                    await this.$download.name(exportRes.msg)
                    this.clearTableCheck()
                    break
                case 4:
                    //耗材订单开票
                    this.goMallInvoiceApply({
                        orderIds: this.selectList,
                        subjectType: 'PERSONAL',
                        invoiceTotalMoney: this.experimentTotalCost
                    })
                    break
            }
        },
        // 关闭【立即还款】弹框
        closeRepayDialog() {
            this.repayment = '1'
        },
        //【立即还款】
        async repay() {
            this.repayLoading = true
            try {
                await orderRepayment(this.orderRepaymentData)
                this.repayLoading = false
                this.repayDialog = false
                this.clearTableCheck()
                this.$message.success('还款成功！')
                this.getOrderList()
            } catch {
                this.repayLoading = false
            }
        },
        backAndRefresh() {
            this.applicationPrePage = false,
            this.clearTableCheck()
            this.getOrderList()
        },
        // 耗材开票返回并刷新列表
        backMallInvoiceAndRefresh() {
            this.mallInvoiceApplyPage = false
            this.getOrderList()
        },
        //关闭【下载实验结果】弹框
        closeEmailDialog() {
            this.emailValidate = true
        },
        //校验【邮箱】
        validateEmail() {
            const rule = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
            this.emailValidate = rule.test(this.email)
        },
        //【发送邮箱】
        async mailSend() {
            this.validateEmail()
            const params = {
                email: this.email,
                orderIds: this.selectList.join(',')
            }
            this.EmailLoading = true
            await EMailSend(params)
            this.EmailLoading = false
            this.EmailDialog = false
            this.clearTableCheck()
            this.$message.success('发送邮箱成功！')
        },
        // 根据路由参数自动打开耗材开票组件
        async openMallInvoiceApplyFromRoute(orderId) {
            this.loading = true
            const res = await mallOrderInfo({ orderId, clientId: this.userInfo.clientId })
            const data = {
                orderIds: [orderId],
                subjectType: 'PERSONAL',
			    invoiceTotalMoney: res.data.amount.paidAmount,
            }
            this.loading = false
            this.goMallInvoiceApply(data)
        },
        // 打开耗材开票组件
        goMallInvoiceApply(data) {
            this.mallInvoiceApplyPage = true
            this.$nextTick(() => {
                if(this.$refs.mallInvoiceApply) {
                    this.$refs.mallInvoiceApply.init(data)
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.disable-table-select-all ::v-deep .el-table__header-wrapper .el-table-column--selection .el-checkbox {
    display: none;
}
.container {
    width: 100%;
    height: calc(100vh - 200px);
    .desc {
        display: flex;
        justify-content: center;
    	align-items: center;
    	height: 50px;
        font-size: 14px;
    	color: #FF4A2B;
        border: 1px solid #EBEEF5;
    	background-color: #FFF2F0;
    }
}
.equipmentPic {
    width: 100px;
    height: 100px;
}
.validate-false {
    border: 1px solid #FF4A2B;
    border-radius: 5px;
}

.tabBar {
    display: flex;
    width: 100%;
    .tabBar-item {
        cursor: pointer;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 12px;
        border: 1px solid #EBEEF5;
        border-right: none;
        border-bottom: none;
    }
    .tabBar-item:last-child {
        border-right: 1px solid #EBEEF5;
    }
    .cursor-item:hover {
        color: #fff;
        font-weight: 600;
        background-color: #84B7F950;
    }
    .tabBar-itam-active {
        color: #fff;
        font-weight: 600;
        background-color: #84B7F9;
    }
}
.serach-box {
	display: flex;
    column-gap: 15px;
    row-gap: 10px;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 15px;
    .filter-input {
        width: 220px;
    }
}
.table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    .button-box {
        display: flex;
        column-gap: 15px;
        align-items: center;
        height: 60px;
        color: #FF4A2B;
    }
}
.repay-dialog {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    .repay-item {
        display: flex;
        .item-title {
            width: 100px;
        }
        .wxQrCode {
            width: 200px;
            height: 200px;
            border-radius: 10px;
            border: 1px solid #ddd;
            background-color: pink;
        }
    }

}

</style>